import { SetStateAction, useCallback, useState } from 'react';

// export const useToggle = (
//   initialState: boolean,
// ): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
//   const [state, setState] = useState(initialState);

//   const toggle = useCallback((nextState?: boolean) => {
//     return setState((prev) => (nextState !== undefined ? nextState : !prev));
//   }, []);

//   return [state, toggle];
// };
export type ToggleAction = SetStateAction<boolean>;

export const useToggle = (
  initialState: boolean | (() => boolean),
): [boolean, (value: ToggleAction) => void] => {
  const [state, setState] = useState(
    typeof initialState === 'function' ? initialState() : initialState,
  );

  const toggle = useCallback((value: ToggleAction) => {
    setState((prev) => {
      if (typeof value === 'function') {
        return value(prev);
      }

      return value;
    });
  }, []);

  return [state, toggle];
};
